import { useCookies } from "../../core/cookies.core";
import LogoutComp from "../menu/logout.comp";
import UserAliasComp from "../menu/userAlias.comp";
import ShopList from "../profile/profileShopList";
import ApperanceToggleComp from "./apperanceToggle.comp";
import ClientLogo from "./clientLogo.comp";

export default function TopRightPanelComp() {
  const isClientLogo = useCookies("isClientLogo");
  return (
    <div className="flex items-center gap-4">
      {isClientLogo ? (
        <ClientLogo />
      ) : (
        <div className="hidden md:block">
          <ShopList />
        </div>
      )}
      <ApperanceToggleComp />
      <LogoutComp />
      <UserAliasComp />
    </div>
  );
}
